<template>
    <div class="as-mallitem_advanced_selector">
        <slot name="custorm" >
            <as-selector @click.native="onShowDialog" :label="label" :default="selectViewData"></as-selector>
        </slot>
        <as-mallitem-dialog-selector
            ref="dialogSelector"
            v-on="$listeners"
            v-bind="$attrs"
            v-model="dialogVisible"
            :loading="dialogLoading"
            :group-data="selectorData"
            :sidebar-list="sidebarData"
            :default-checked-keys="defaultCheckedKeys"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem">
        </as-mallitem-dialog-selector>
    </div>
</template>

<script>
    import AsSelector from '@/components/selector';
    import AsMallitemDialogSelector from '@/components/mallitem-dialog-selector'
    import AdvancedSelector from '@/components/advanced-selector'
    export default {
        extends: AdvancedSelector,
        name: 'AsMallitemAdvancedSelector',
        components: {
            AsSelector,
            AsMallitemDialogSelector,
        },
        props: {
            filterMethod: Function,
            defaultSelectView: {
                type: String,
                default: '',
            }
        },
        computed: {
            selectViewData() {
                const label = 'name';
                const count = this.selectListData ? this.selectListData.length : 0;
                if (!count) return this.defaultSelectData;
                const appendFixLabel = count > 1 ? `+ ${count - 1}` : '';
                const name = `${this.selectListData[0][label]}${appendFixLabel}`;
                return {
                    name,
                }
            },
        },
        methods: {
            loadDataCallback(mallItemListData) {
                const categoryGroupData = {};
                const categoryMapData = {};
                for(let i =0 ;i< mallItemListData.length;i++){
                    const itemData = mallItemListData[i];
                    const valid = this.filterMethod ? this.filterMethod(itemData) : true;
                    if (!valid) continue;
                    const categoryKey = itemData.subCategory;
                    if (!categoryGroupData[categoryKey]) {
                        categoryGroupData[categoryKey] = [];
                        categoryMapData[categoryKey] = {
                            id: categoryKey,
                            name: itemData.subCategoryName,
                            category: itemData.category,
                        }
                    }
                    categoryGroupData[categoryKey].push(itemData);
                }
                const listData = [];
                const sidebarListData = [];
                for(let categoryId in categoryGroupData) {
                    const categoryData = categoryMapData[categoryId];
                    const categoryChildrenData = categoryGroupData[categoryId];
                    sidebarListData.push(categoryData);
                    categoryData.children = categoryChildrenData;
                    listData.push(categoryData);
                }
                this.dialogLoading = false;
                this.loadSelectorData = listData;
                this.loadSidebarData = sidebarListData;
            },
        }
    }
</script>
<style lang="scss">
.as-mallitem_advanced_selector {
    display: inline-flex;
}
</style>